/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import { Box, Grid, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { DataGridPro as DataGrid } from '@mui/x-data-grid-pro';
import api from '../components/api/surveyApi';
import { getSurveyTableColumns } from '../components/GridColumns';
import { QuickSearchToolbar } from '../components/QuickSearch';

export const SurveyPage = () => {
  const [surveysData, setSurveysData] = useState([]);
  const [filteredSurveys, setFilteredSurveys] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const { data } = await api.get('/v1/admin/surveys?pageSize=50&pageNumber=1');
        console.log('Survey API Response:', data);
        const actualData = Array.isArray(data)
          ? data
          : data?.data || data?.surveys || data?.items || [];

        const rows = actualData.map((item, index) => ({
          ...item,
          id: item.publicId || item.PK || index
        }));

        setSurveysData(rows);
        setFilteredSurveys(rows);
      } catch (err) {
        console.error('Failed to fetch surveys', err);
        setSurveysData([]);
        setFilteredSurveys([]);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, []);

  const escapeRegExp = (value) => value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

  const requestSearch = (searchValue) => {
    setSearchText(searchValue);
    const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
    const filteredRows = surveysData.filter((row) =>
      Object.keys(row).some((field) => {
        if (!['name', 'createdAt', 'description'].includes(field)) {
          return false;
        }
        return searchRegex.test(row[field]?.toString());
      })
    );
    setFilteredSurveys(filteredRows);
  };

  const handleRowClick = (params) => {
    const { row } = params;
    const surveyId = row.publicId || row.id;
    window.open(`/dashboard/survey-details?id=${surveyId}`, '_blank');
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" style={{ margin: 10 }}>
        Survey
      </Typography>

      <Grid
        item
        style={{
          flexGrow: 1,
          height: '75vh',
          width: '100%'
        }}
      >
        <DataGrid
          components={{
            Toolbar: QuickSearchToolbar
          }}
          sx={{
            '& .MuiDataGrid-row': {
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: '#f5f5f5'
              }
            }
          }}
          componentsProps={{
            toolbar: {
              value: searchText,
              onChange: (event) => requestSearch(event.target.value),
              clearSearch: () => requestSearch('')
            }
          }}
          loading={loading}
          rows={filteredSurveys || []}
          columns={getSurveyTableColumns()}
          pageSize={50}
          onRowClick={handleRowClick}
          disableSelectionOnClick
        />
      </Grid>
    </Box>
  );
};
